import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import common from './common'
import { createPinia } from 'pinia'

import Select from '@/components/Select'
import SelectSizeM from '@/components/SelectSizeM'
import ManufactureSelect from '@/components/ManufacturerSelect'
import CarTypeSelect from '@/components/CarTypeSelect'
import jQuery from 'jquery'
import smoothScroll from 'vue-smoothscroll'
import ModalAlert from './components/Modal/Alert'
import LazyYoutubeVideo from '@/components/VueLazyYoutubeVideo'
import LoadScript from 'vue-plugin-load-script'
// v2
import commonV2 from '@/v2/common'
import SelectV2 from '@/components/v2/Select'
import SelectSizeMV2 from '@/components/v2/SelectSizeM'
import ManufactureSelectV2 from '@/components/v2/ManufacturerSelect'
import CarTypeSelectV2 from '@/components/v2/CarTypeSelect'
import ModalAlertV2 from '@/components/v2/Modal/Alert'
import MPCancelModalAlertV2 from '@/components/v2/Modal/MaintenancePackCancelAlert'
import CompleteModalAlertV2 from '@/components/v2/Modal/CompleteAlert'
import AdmissionFeeReminderAlertV2 from '@/components/v2/Modal/AdmissionFeeReminderAlert'
import LazyYoutubeVideoV2 from '@/components/v2/VueLazyYoutubeVideo'
import MPSpecifiedCommercialTransactionsModalAlertV2 from '@/components/v2/Modal/MaintenancePackSpecifiedCommercialTransactionsAlert'

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

const app = createApp(App)
app.use(router)
app.use(store)
app.use(smoothScroll)
app.use(LoadScript)

const pinia = createPinia()
app.use(pinia)

// v1
app.component('vue-select', Select)
app.component('vue-select-m', SelectSizeM)
app.component('vue-manufacture-select', ManufactureSelect)
app.component('vue-car-type-select', CarTypeSelect)
app.component('modal-alert', ModalAlert)
app.component('LazyYoutubeVideo', LazyYoutubeVideo)

// v2
app.component('vue-select-v2', SelectV2)
app.component('vue-select-m-v2', SelectSizeMV2)
app.component('vue-manufacture-select-v2', ManufactureSelectV2)
app.component('vue-car-type-select-v2', CarTypeSelectV2)
app.component('modal-alert-v2', ModalAlertV2)
app.component('mp-cancel-modal-alert-v2', MPCancelModalAlertV2)
app.component('complete-modal-alert-v2', CompleteModalAlertV2)
app.component('admission-fee-reminder-alert-v2', AdmissionFeeReminderAlertV2)
app.component('LazyYoutubeVideoV2', LazyYoutubeVideoV2)
app.component('mp-specified-commercial-transactions-alert-v2', MPSpecifiedCommercialTransactionsModalAlertV2)

if (window.location.href.match(/v2/)) {
  app.mixin(commonV2)
} else {
  app.mixin(common)
}

app.config.globalProperties.$filters = {
  addComma (val) {
    return val.toLocaleString()
  },
  checkFirstYear (val) {
    return (val === 1) ? '元' : val
  },
  roundDown (val) {
    return Math.floor(val)
  },
  oilExchanged (val) {
    return (val === 0) ? '必要' : '不要'
  }
}

app.mount('#app')
